module.exports = __webpack_public_path__ + "static/img/circle-2.d7fe959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/circle-2.png
// module id = 2CsU
// module chunks = 0